import { render } from "./Wave.vue?vue&type=template&id=f70d5486&lang=pug"
import script from "./Wave.vue?vue&type=script&lang=js"
export * from "./Wave.vue?vue&type=script&lang=js"

import "./Wave.vue?vue&type=style&index=0&id=f70d5486&lang=stylus"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__